import { render, staticRenderFns } from "./WPLink.vue?vue&type=template&id=58f498ee&lang=pug&"
import script from "./WPLink.vue?vue&type=script&lang=js&"
export * from "./WPLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports